const initialState = {
    friends: [
      {name: 'Артем', avatar: 'https://sun9-56.userapi.com/c627221/v627221045/1f868/BSgDaLPthEU.jpg'},
      {name: 'Динара', avatar: 'https://sun9-20.userapi.com/c858420/v858420872/15fe20/ZyIMsPbQkfE.jpg'},
      {name: 'Антон', avatar: 'https://sun9-11.userapi.com/c625825/v625825771/41496/azh0iVZs5JY.jpg'},
      {name: 'Николай', avatar: 'https://sun9-42.userapi.com/c840230/v840230984/58de1/zHlKOZkHGPk.jpg'},
    ]
  }

const navbarReducer = (state = initialState, action) => {

    
    return state;
}

export default navbarReducer;